import PropTypes from "prop-types";

import ShareIcon from "@/icons/ShareIcon";
import SecondaryActionButton from "../../SecondaryActionsToolbar/SecondaryActionButton";
import { shareActionIconCss } from "./ShareAction.style";
import ShareOptions from "./ShareOptions";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevelId: PropTypes.string,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
};

const ShareAction = ({
  contentId,
  contentType,
  currentLevelId,
  hoverLabel,
  isMobile,
  thumbnail,
  title,
}) => {
  const ariaProps = {
    "aria-label": "Share",
  };

  const eventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName: "Share",
    streamProperties: {
      content_type: contentType,
      description: "Open share options list",
      content_id: currentLevelId,
    },
  };

  const popOutContents = (
    <ShareOptions
      contentId={contentId}
      contentType={contentType}
      currentLevelId={currentLevelId}
      isMobile={isMobile}
      thumbnail={thumbnail}
      title={title}
    />
  );

  const icon = <ShareIcon css={shareActionIconCss} />;

  return (
    <SecondaryActionButton
      dataProps={{ "data-qa-selector": "share" }}
      ariaProps={ariaProps}
      hoverLabel={hoverLabel}
      icon={icon}
      title="Share"
      popOutContents={popOutContents}
      eventProperties={eventProperties}
    />
  );
};

ShareAction.propTypes = propTypes;

export default ShareAction;
